import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { accountsApi } from '../../utils/accountsApi';
import ChartOfAccountsCardView from './ChartOfAccountsCardView';
import './ChartOfAccountsPage.css';

const ChartOfAccountsCardPage = () => {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchAccounts = () => {
        setLoading(true);
        accountsApi.list({ limit: 500 })
            .then(res => setAccounts(res.items))
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    };

    useEffect(() => { fetchAccounts(); }, []);

    const handleEdit = account => {
        navigate(`/chart-of-accounts/table`, { state: { editId: account.id } });
    };

    const handleDelete = async id => {
        if (!window.confirm('Deactivate this account?')) return;
        try {
            await accountsApi.remove(id);
            fetchAccounts();
        } catch (err) {
            alert('Error: ' + err.message);
        }
    };

    if (loading) return <div className="loading">Loading accounts…</div>;
    if (error) return <div className="error">Error: {error}</div>;

    return (
        <div className="chart-of-accounts-page">
            <div className="page-header">
                <h1>Chart of Accounts — Card View</h1>
            </div>
            <div className="view-container">
                <ChartOfAccountsCardView
                    accounts={accounts}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                />
            </div>
        </div>
    );
};

export default ChartOfAccountsCardPage;
